import { render } from "./Termos.vue?vue&type=template&id=025c4de4"
import script from "./Termos.vue?vue&type=script&lang=js"
export * from "./Termos.vue?vue&type=script&lang=js"

import "./Termos.vue?vue&type=style&index=0&id=025c4de4&lang=css"

import exportComponent from "/home/thales/Projetos/termos-telemidia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__